import { render } from "./GeneralNotification.vue?vue&type=template&id=3489099c&scoped=true"
import script from "./GeneralNotification.vue?vue&type=script&lang=js"
export * from "./GeneralNotification.vue?vue&type=script&lang=js"

import "./GeneralNotification.vue?vue&type=style&index=0&id=3489099c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3489099c"]])

export default __exports__